module.exports = __webpack_public_path__ + "static/media/About-Us.62bd50bb.jpg";